export const WHATSAPP_NUMBER = '573208351887';

export const WHATSAPP_MESSAGE =
  'Hola, quiero que me ayuden a organizar y automatizar la agenda de mi negocio.';

export function createWhatsAppUrl(message = WHATSAPP_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const WHATSAPP_URL = createWhatsAppUrl();
